.ux-spinner-overlay {
  display: block;
  height: 100%;
  left: 0;
  overflow: hidden;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: $z-index-spinner-overlay;

  &--closed {
    display: none;
  }

  &__backdrop {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(0 0 0 / 30%);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    .ux-spinner-overlay--opening & {
      opacity: 0;
    }

    .ux-spinner-overlay--opened & {
      opacity: 1;
      transition: opacity $animationSpeed-fast ease-out;
    }

    .ux-spinner-overlay--closing & {
      opacity: 0;
      transition: opacity $animationSpeed-fast ease-out;
    }

    .ux-spinner-overlay--closed & {
      opacity: 0;
    }
  }

  &__container {
    display: block;
    background-color: white;
    text-align: center;
    width: 90%;
    padding: 30px;

    @media (width >= 768px) {
      padding: 50px;
      width: 83.3333%;
    }

    @media (width >= 1024px) {
      max-width: 960px;
      width: 66.6666%;
      padding: 50px;
    }

    ux-loader {
      left: 0;
    }
  }

  &__headline {
    margin-top: 0;
    margin-bottom: 20px;
    &:empty {
      display: none;
    }
  }

  &__subline {
    color: $color-gray-text;
    margin-top: 25px;
    margin-bottom: 0;
    &:empty {
      display: none;
    }
  }

  &__loader {
    display: block;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
